if(typeof FN == 'undefined') FN = {};

FN.contactEnterprise = {
  selectors: {
    enterpriseFormId: 'enterprise-contact__form',
    teamFormId: 'team-contact__form',
    statusMessageClass: 'contact-form__status',
    honeypotSelector: '#field-hp_consent'
  },
  constants: {
    sendingMessage: "Your message is being sent...",
    incompleteMessage: "Please fill all required fields.",
    invalidEmailMessage: "Please provide a valid email address.",
    successMessage: "Thank you! We have received your request and will be in touch shortly!",
    errorMessage: "An error occurred. Please contact support@git-tower.com via email.",
    acceptPrivacyPolicyMessage: "Please read and accept our Privacy Policy.",
    honeypotFilledMessage: "Please don't enter anything into the honeypot field."
  },

  init: function (baseElement, requiredFields, requestURL) {
    if (baseElement.length === 0) {
      return;
    }

    baseElement.submit(function (event) {
      event.preventDefault();
      if (!FN.contactEnterprise.isFormValid(baseElement, requiredFields)) {
        return false;
      }
      FN.contactEnterprise.submitForm($(this), event, requestURL);
    });
  },

  isFormValid: function (baseElement, requiredFields) {
    if (FN.contactEnterprise.honeypotFilled()) {
      FN.contactEnterprise.showStatus(
        baseElement,
        'error',
        FN.contactEnterprise.constants.honeypotFilledMessage
      );
      return false;
    }

    for (var i = 0; i < requiredFields.length; i++) {
      var selector = '[name="' + requiredFields[i] + '"]';
      var field = baseElement.find(selector);

      if (field.length === 0) {
        return false;
      }

      // Handle text inputs and textareas
      if (field.is('input[type="text"]') || field.is('textarea')) {
        var fieldVal = field.val();

        if (fieldVal === "") {
          FN.contactEnterprise.showStatus(
            baseElement,
            'error',
            FN.contactEnterprise.constants.incompleteMessage
          );
          return false;
        }

        // Note that this checks if the input name is "email", not if the input
        // type is email... in fact, the type is already assumed to be text!
        if (requiredFields[i] === 'email') {
          var emailFilter = /^.+@.+\..{2,10}$/;
          if (!(emailFilter.test(fieldVal))) {
            FN.contactEnterprise.showStatus(
              baseElement,
              'error',
              FN.contactEnterprise.constants.invalidEmailMessage
            );
            return false;
          }
        }
      }
      // Handle checkboxes
      else if (field.is('input[type="checkbox"]')) {
        var checked = field.prop('checked');
        if (!checked) {
          if (requiredFields[i] === 'legal') {
            FN.contactEnterprise.showStatus(
              baseElement,
              'error',
              FN.contactEnterprise.constants.acceptPrivacyPolicyMessage
            );
          }
          else {
            FN.contactEnterprise.showStatus(
              baseElement,
              'error',
              FN.contactEnterprise.constants.incompleteMessage
            );
          }
          return false;
        }
      }
    }
    return true;
  },

  honeypotFilled: function () {
    $field = $(FN.contactEnterprise.selectors.honeypotSelector);
    val = $field.val();
    return val !== "";
  },

  showStatus: function (baseElement, status, message) {
    var selector = '.' + FN.contactEnterprise.selectors.statusMessageClass;
    var messageContainer = baseElement.find(selector);
    messageContainer.removeClass(
      'error loading success'
    ).addClass(
      status
    ).html(
      message
    ).show();
  },

  submitForm: function (formElement, event, requestURL) {
    formElement.find('input[type="submit"]').attr('disabled', 'disabled');
    FN.contactEnterprise.showStatus(
      formElement,
      'loading',
      FN.contactEnterprise.constants.sendingMessage
    );

    var formData = FN.contactEnterprise.prepareFormData(formElement);

    $.ajax({
      url: requestURL,
      data: formData,
      type: 'POST',
      success: function (data) {
        FN.contactEnterprise.handleFormResponse(formElement, data);
      },
      error: function (request, status, error) {
        FN.contactEnterprise.showStatus(
          formElement,
          'error',
          FN.contactEnterprise.constants.errorMessage
        );
      }
    });
  },

  prepareFormData: function (formElement) {
    return formElement.serializeArray();
  },

  handleFormResponse: function (formElement, responseData) {
    if (responseData['status'] < 400) {
      FN.contactEnterprise.showStatus(
        formElement,
        'success',
        FN.contactEnterprise.constants.successMessage
      );
      var redirectURL = FN.config.urls.base + FN.config.urls.ticketSupportSuccess;
      window.location = redirectURL;
    }
    else if (responseData['status'] >= 400) {
      FN.contactEnterprise.showStatus(
        formElement,
        'error',
        FN.contactEnterprise.constants.errorMessage
      );
    }
  }
};

$(document).ready (function () {
  FN.contactEnterprise.init(
    $('#' + FN.contactEnterprise.selectors.enterpriseFormId),
    ['name', 'email', 'company', 'legal'],
    FN.config.urls.apiBase + FN.config.urls.apiEnterpriseLead
  );
  FN.contactEnterprise.init(
    $('#' + FN.contactEnterprise.selectors.teamFormId),
    ['name', 'email', 'company', 'team_size', 'legal'],
    FN.config.urls.apiBase + FN.config.urls.apiTeamLead
  );
});
